import { Link } from 'react-router-dom'
import { Gift, Users, Trophy, Calendar, BarChart3 } from 'lucide-react'

const Home = () => {
  return (
    <div className="bg-gradient-to-br from-primary-50 to-blue-100 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            Bem-vindo ao{' '}
            <span className="text-primary-600">FENAE Sorteios</span>
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Participe dos nossos sorteios exclusivos e concorra a prêmios incríveis!
            Uma plataforma segura e transparente para todos os associados FENAE.
          </p>
          <div className="flex justify-center">
            <Link
              to="/resultados"
              className="btn btn-primary text-lg px-8 py-3"
            >
              Ver Resultados
            </Link>
          </div>
        </div>

        {/* Features Section */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          <div className="card text-center">
            <Gift className="h-12 w-12 text-primary-600 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">Sorteios Exclusivos</h3>
            <p className="text-gray-600">
              Participe de sorteios únicos disponíveis apenas para associados FENAE.
            </p>
          </div>
          
          <div className="card text-center">
            <Users className="h-12 w-12 text-primary-600 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">Comunidade</h3>
            <p className="text-gray-600">
              Faça parte de uma comunidade ativa de associados e funcionários.
            </p>
          </div>
          
          <div className="card text-center">
            <Trophy className="h-12 w-12 text-primary-600 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">Prêmios Incríveis</h3>
            <p className="text-gray-600">
              Concorra a prêmios valiosos e experiências únicas.
            </p>
          </div>
          
          <div className="card text-center">
            <Calendar className="h-12 w-12 text-primary-600 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">Sempre Atualizado</h3>
            <p className="text-gray-600">
              Novos sorteios regularmente com datas e horários claros.
            </p>
          </div>
        </div>

        {/* Campanhas Card Section */}
        <div className="mb-16">
          <Link
            to="/campanhas"
            className="card text-center hover:shadow-lg transition-shadow cursor-pointer block"
          >
            <BarChart3 className="h-16 w-16 text-primary-600 mx-auto mb-4" />
            <h3 className="text-2xl font-semibold mb-2 text-gray-900">Campanhas</h3>
            <p className="text-gray-600">
              Explore todas as campanhas disponíveis e veja os detalhes de cada uma.
            </p>
          </Link>
        </div>

        {/* CTA Section */}
        <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Pronto para começar?
          </h2>
          <p className="text-gray-600 mb-6">
            Consulte os resultados dos sorteios executados e veja os participantes sorteados!
          </p>
          <Link
            to="/resultados"
            className="btn btn-primary text-lg px-8 py-3"
          >
            Ver Resultados
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Home
